import { withProps } from '../../../libs/react-utils';
import Field from './Field';
import TextInput from './TextInput';

export default withProps({ Input: TextInput }, Field);
